// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"73005cbc","838":"1f5dbc3f"}[chunkId] + ".chunk.js";
};